import { type RoutePreviewPoint } from './route-preview.ts'

const encodeValue = (value: number) => {
  let encoded = ''
  let current = value < 0 ? ~(value << 1) : value << 1

  while (current >= 0x20) {
    encoded += String.fromCharCode((0x20 | (current & 0x1f)) + 63)
    current >>= 5
  }

  encoded += String.fromCharCode(current + 63)

  return encoded
}

export const encodePath = (points: RoutePreviewPoint[]) => {
  let encodedPath = ''
  let previousLat = 0
  let previousLng = 0

  for (const point of points) {
    const lat = Math.round(point.lat * 1e5)
    const lng = Math.round(point.lng * 1e5)

    encodedPath += encodeValue(lat - previousLat)
    encodedPath += encodeValue(lng - previousLng)

    previousLat = lat
    previousLng = lng
  }

  return encodedPath
}
